export { DemographicsSection } from './demographics-section';
export type { DemographicsSectionProps } from '@/types/demographics';
